module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_buchung 5 ro.c5947723.svg";